import React from 'react';

function Footer() {
  return (
    <footer className="font-sans relative pt-5 pb-5 bg-gradient-to-r from-amber-600 to-amber-800" data-testid="footer">
      <div className="flex flex-col items-center justify-center text-center" data-testid="footer-content">
        
        <p className="text-sm text-gray-900 dark:text-gray-100" data-testid="footer-copyright">
          © Parqueo, Bogotá, Colombia, 2025.
        </p>
        <p className="text-sm text-gray-900 dark:text-gray-100" data-testid="footer-powered">
          Powered by <a href="https://sojoj.com/" className="text-indigo-600 dark:text-indigo-400 hover:underline" data-testid="footer-link">Jonhathan Sojo</a>
        </p>
      </div>
    </footer>
  );
}

export {Footer}
